/**
 * Supported template types
 */
export enum TemplateType {
    SCHEDULE = 'schedule',
    MEDALLION = 'medallion',
    CONTENT = 'content',
    WEATHER = 'weather',
    QUOTE = 'quote',
}

export type RawTemplate = {
    id: number | string;
    type: TemplateType;
    html: string | null;
    css: string | null;
    js: string | null;
};

/**
 * Available template engines
 */
export enum TemplateEngine {
    HANDLEBARS = 'handlebars',
    VUE = 'vue',
}

/**
 * Generic template configuration shape
 */
export interface TemplateConfiguration {
    id: string;
    type: TemplateType;
    framework: TemplateEngine;
}
